import { render } from "./CompanyComponent.vue?vue&type=template&id=1917c8e2"
import script from "./CompanyComponent.vue?vue&type=script&lang=js"
export * from "./CompanyComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__